<template>
  <div class="check-square" :class="{on:check}" @click="$emit('update:check', !check)">
    <slot/>
    <check-outlined v-if="check"/>
  </div>
</template>

<script setup lang="ts">

import {CheckOutlined} from "@ant-design/icons-vue";

defineProps<{ check: boolean }>()
defineEmits(['update:check'])
</script>

<style scoped lang="sass">
.check-square
  cursor: pointer
  border: 1px var(--ant-color-border) solid
  position: relative
  border-radius: 10px
  background-color: var(--ant-color-primary-bg)

  &:hover
    border: 1px var(--ant-color-primary) solid

  &.on
    border: 1px var(--ant-color-primary) solid
    background-color: var(--ant-color-primary-bg-hover)


  > .anticon
    position: absolute
    right: -8px
    top: -8px
    border-radius: 11px
    color: white
    background-color: var(--ant-color-primary)
    padding: 4px
</style>